<section class="recent-card">
  <h2 class="recent-title">{{ title }}</h2>

  <div class="recent-scroll">
    <div *ngIf="loading" class="flex items-center justify-center py-10">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>

    <p *ngIf="!loading && items.length === 0" class="recent-empty">
      {{ emptyMessage }}
    </p>

    <ul *ngIf="!loading && items.length > 0" class="recent-list">
      <li *ngFor="let item of items" class="recent-row">
        <span class="role-badge" [class.role-badge--billing]="isBillingAssignment(item)">{{ roleBadge(item) }}</span>
        <div class="recent-body">
          <div class="client-name">{{ item.clientName }}</div>
          <div class="recent-meta">
            Assigned {{ item.effectiveFrom | date:'MMM d, y' }}<ng-container *ngIf="scope === 'all' && item.staffDisplayName"> · {{ item.staffDisplayName }}</ng-container><ng-container *ngIf="item.handedOffFromSales"> · handed off from Sales</ng-container>
          </div>
        </div>
        <a class="view-link" [routerLink]="['/clients', item.mCode]">View</a>
      </li>
    </ul>
  </div>
</section>
